module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_0.e4eb6611.png";